import PlayerSearchPage from "../components/playerSearch/PlayerSearchPage";

export default PlayerSearchPage;
